// extracted by mini-css-extract-plugin
module.exports = {"container":"Blobs-module--container--hwIu7","canvas":"Blobs-module--canvas--_tyDl","show":"Blobs-module--show--28-KW"};